import * as React from "react";
import styled from "styled-components";
import ConnectionErrors, {
  NotificationContainer,
  Title
} from "components/authentication/directoryServices/BackendWizard/ConnectionErrors";
const Table = styled.table`
  width: 250px;
  margin-bottom: 0;
`;
const TriggerTeamSyncResponse = ({ response }) => {
  const { success, message, errors, createdTeams = [], deletedTeams = [], updatedTeams = [] } = response;
  if (errors && errors.length >= 1) {
    return /* @__PURE__ */ React.createElement(ConnectionErrors, { errors, message });
  }
  return /* @__PURE__ */ React.createElement(NotificationContainer, { bsStyle: success ? "success" : "danger" }, /* @__PURE__ */ React.createElement(Title, null, message), /* @__PURE__ */ React.createElement(Table, { className: "table" }, /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { className: "limited" }, "Created Teams"), /* @__PURE__ */ React.createElement("td", null, createdTeams.length)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { className: "limited" }, "Updated Teams"), /* @__PURE__ */ React.createElement("td", null, updatedTeams.length)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { className: "limited" }, "Deleted Teams"), /* @__PURE__ */ React.createElement("td", null, deletedTeams.length)))));
};
export default TriggerTeamSyncResponse;
